const DEFAULT_MAX_RETRIES = 2;
const MAX_RETRY_DELAY_MS = 60_000;

const retryDelayMs = (response) => {
  const retryAfter = Number(response.headers.get("Retry-After"));
  if (!Number.isFinite(retryAfter) || retryAfter < 0) {
    return 1000;
  }
  return Math.min(retryAfter * 1000 + 100, MAX_RETRY_DELAY_MS);
};

/**
 * Retries a request rejected by the server-side token bucket. A 429 response
 * is guaranteed not to have reached the controller, so retrying these POSTs
 * cannot duplicate a write.
 */
export async function fetchWithRateLimitRetry(
  input,
  init,
  { maxRetries = DEFAULT_MAX_RETRIES } = {}
) {
  let response;

  for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
    response = await fetch(input, init);
    if (response.status !== 429 || attempt === maxRetries) {
      return response;
    }

    await new Promise((resolve) => setTimeout(resolve, retryDelayMs(response)));
  }

  return response;
}
